export const HUB_BANNER_CONSTANTS = {
  AUTO_ROTATE_INTERVAL: 7000, // 7 seconds
  TRANSITION_DURATION: 500, // 0.5 seconds
  SWIPE_THRESHOLD: 50, // pixels
  HEIGHT: 100, // pixels - banner height
} as const;

export const IMAGE_BREAKPOINT = {
  EXTRA_SMALL: "extraSmall",
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large",
} as const;

export type ImageBreakpoint = (typeof IMAGE_BREAKPOINT)[keyof typeof IMAGE_BREAKPOINT];

export const BANNER_PX_BREAKPOINTS = {
  EXTRA_SMALL: 380,
  SMALL: 768,
  MEDIUM: 1280,
  LARGE: 1440,
} as const;

// Banner image breakpoints aligned with app breakpoints (md: 768px, lg: 1280px)
// Banners are centered at their native size, so we pick the right image based on viewport
export const BANNER_BREAKPOINTS = {
  PHONE_MAX: BANNER_PX_BREAKPOINTS.SMALL - 1, // < 768px (mobile) → 380px banner
  SMALL_MIN: BANNER_PX_BREAKPOINTS.SMALL,
  SMALL_MAX: BANNER_PX_BREAKPOINTS.MEDIUM - 1, // 768-1279px (tablet) → 768px banner
  MEDIUM_MIN: BANNER_PX_BREAKPOINTS.MEDIUM,
  MEDIUM_MAX: BANNER_PX_BREAKPOINTS.LARGE - 1, // 1280-1439px → 1280px banner
  LAPTOP_MIN: BANNER_PX_BREAKPOINTS.LARGE, // ≥ 1440px (large desktop) → 1440px banner
} as const;
